import { useFiltersV2Actions, useFiltersV2Select } from "PFApp/components/filters_v2/stores";
import { FilterV2ComponentLabels } from "PFApp/components/filters_v2/types";
import SidePanel from "PFComponents/side_panel/side_panel";
import { FilterKeyV2 } from "PFTypes/filters_v2";
import { useRef } from "react";

import { FiltersV2PanelContent } from "./parts/filters_v2_panel_content";
import { FiltersV2PanelFooter } from "./parts/filters_v2_panel_footer";
import { FiltersV2PanelHeader } from "./parts/filters_v2_panel_header";

type OmitParams = {
  main?: FilterKeyV2[];
  children?: FilterKeyV2[];
};

export type SavedFiltersProps = {
  omit?: OmitParams;
};

export type FiltersV2PanelProps = {
  omit?: OmitParams;
  labels?: FilterV2ComponentLabels;
  childrenToggleInfo?: string;
  savedFiltersProps?: SavedFiltersProps;
};

const FiltersV2PanelRoot = (props: FiltersV2PanelProps) => {
  const { toggleFiltersSidePanel } = useFiltersV2Actions();

  const lastFocusedFilterNameRef = useRef(null);

  return (
    <SidePanel
      onClose={() => toggleFiltersSidePanel(false)}
      title={<FiltersV2PanelHeader lastFocusedFilterNameRef={lastFocusedFilterNameRef} />}
      show
      fullHeight
      size="large"
      footerRenderer={({ onSidePanelClose }) => (
        <FiltersV2PanelFooter
          onSidePanelClose={onSidePanelClose}
          savedFiltersProps={props.savedFiltersProps}
        />
      )}
      qaId="FiltersPanel"
    >
      <FiltersV2PanelContent lastFocusedFilterNameRef={lastFocusedFilterNameRef} {...props} />
    </SidePanel>
  );
};

export const FiltersV2Panel = (props: FiltersV2PanelProps) => {
  const { isSidePanelOpen } = useFiltersV2Select("isSidePanelOpen");

  if (!isSidePanelOpen) {
    return null;
  }

  return <FiltersV2PanelRoot {...props} />;
};
